module.exports = __webpack_public_path__ + "img/icon15.a353758c.png";